import React from 'react';

declare global {
  interface Window {
    prerenderReady?: boolean;
  }
}

export type PageReadyOptions<T  extends string> = {
  [key in T]?: boolean;
}; 

export type PageState<T  extends string> = Record<T, unknown>; 

export const prerenderHooks = {
  usePrerenderReady(ready: boolean) {
    React.useLayoutEffect(() => {
      window.prerenderReady = ready;
    }, [ready]);
  },
  useCumulatedState<T  extends string>(
    options: PageReadyOptions<T>, state: PageState<T>
  ) {
    const result = React.useMemo(() =>
      Object.keys(state).reduce((acc, key: T) => {
        return acc && (!!state[key] || !options[key]);
      }, true), [state, options]);
    return result;
  },
};